export const settings = {
  state: {
    settings: {},
    whatsappAccounts: [],
    widgetSettings: "",
    pagination: {
      page: 1,
      rowsPerPage: 25, // -1 for All",
    },
  },
  mutations: {
    SET_SETTINGS(state, settings) {
      state.settings = settings;
    },
    SET_WIDGET_SETTINGS(state, widgetSettings) {
      state.widgetSettings = widgetSettings;
    },
    SET_TABLES_NUMBER_OF_ROWS(state, tablesNumberOfRows) {
      state.pagination.rowsPerPage = parseInt(tablesNumberOfRows);
    },
    SET_WHATSAPP_ACCOUNTS(state, accounts) {
      state.whatsappAccounts = accounts;
    },
  },
  actions: {
    setSettings({ commit }, settings) {
      commit("SET_SETTINGS", settings);
    },
    setWidgetSettings({ commit }, widgetSettings) {
      commit("SET_WIDGET_SETTINGS", widgetSettings);
    },
    setTableNumberOfRows({ commit }, tablesNumberOfRows) {
      commit("SET_TABLES_NUMBER_OF_ROWS", tablesNumberOfRows);
      localStorage.setItem("tablesNumberOfRows", tablesNumberOfRows);
    },
    setWhatsAppAccounts({ commit }, accounts) {
      commit("SET_WHATSAPP_ACCOUNTS", accounts);
    },
    getWhatsAppAccounts: async function ({ commit, dispatch, getters }) {
      try {
        const botId = getters["bot/id"];

        if (!botId) return false;
        dispatch("setLoader", true);
        const { data } = await this._vm.$http_session_manager({
          method: "get",
          url: `bots/${botId}/apps/whatsapp/list`,
        });

        commit("SET_WHATSAPP_ACCOUNTS", data.whatsapp_apps);
      } catch (err) {
        commit("SET_WHATSAPP_ACCOUNTS", []);
        throw err;
      }
    },
    addWhatsAppAccountByEmbeddedSignup: async function (
      { commit, dispatch, getters },
      payload
    ) {
      try {
        const botId = getters["bot/id"];
        if (!botId) return false;
        dispatch("setLoader", true);

        const response = await this._vm.$http_session_manager({
          method: "post",
          url: `bots/${botId}/apps/whatsapp/embedded-signup`,
          data: payload,
        });
        dispatch("setLoader", false);

        commit("SET_WHATSAPP_ACCOUNTS", response.data);
      } catch (err) {
        throw err;
      }
    },
  },
};
